<template>

  <div id="wire_details" v-if="showWindow">
    
<vs-popup classContent="popup-example" title="Add Bank" :active.sync="popupAddBank">
       
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
           Beneficiary Name
           <vs-input class="inputx w-full" v-model="params.beneficiary_name" />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          Beneficiary Address
           <vs-input class="inputx w-full" v-model="params.beneficiary_address" />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          Bank Name
           <vs-input class="inputx w-full" v-model="params.bank_name" />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          Bank Address
           <vs-input class="inputx w-full" v-model="params.bank_address" />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          IBAN
           <vs-input class="inputx w-full" v-model="params.iban" />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          SWIFT
           <vs-input class="inputx w-full" v-model="params.swift" />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          Bank Country
           <v-select required v-model="params.country" label="cl_Country" :options="country" :dir="$vs.rtl ? 'rtl' : 'ltr'"  />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          Currency
           <v-select required v-model="params.currency" label="currency" :options="currency" :dir="$vs.rtl ? 'rtl' : 'ltr'"   />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          Allowed Countries
           <v-select v-model="params.selectedAllowedCountries" label="cl_Country" :options="country" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'"  />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full"> 
          Blocked Countries
           <v-select v-model="params.selectedBlockedCountries" label="cl_Country" :options="country" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'"  />
         </div>
       </div>
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
          Incoming Commission
           <vs-input type="number" class="inputx w-full" v-model="params.commission" />
         </div>
       </div>
 
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
           <vs-button @click="sendData('add-bank')" color="primary" type="filled">Add</vs-button>
         </div>
       </div>
     </vs-popup>
     
     

     <vs-button color="warning" type="border" class="mr-3 mb-2" @click="popupAddBank=true">Add Bank</vs-button>



    <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :filters="filters"
      ref="tableView"
      >
    </table-view>
  </div>
</template>
 
<script>

import tableView from '../../components/tableView';
import country from '../../../resources/country.json';
import vSelect from 'vue-select';
import axios from "@/axios.js";
export default {
  components: {   
    tableView,
    'v-select': vSelect
  },
  data() {
    
    let data = {
      params:{},
      endPoint:'wire_detail_section',
      filters: {
        brokers: true,
        status: true
      },
      selectedAllowedCountries: [],
      selectedBlockedCountries: [],
      popupAddBank: false,
      country: country,
      currency:['EUR','GBP','USD','AUD','CAD'],
      buttons:{
          remove_bank: true,
      },

    }
    let firstColumns = {
       headerName: 'Select',
       field: 'select',
        
       width: 125,
       checkboxSelection: true,
       headerCheckboxSelectionFilteredOnly: true,
       headerCheckboxSelection: true,
       
     }
    data.columnDefs= JSON.parse(localStorage.getItem('wireDetailsColumns'))
    data.columnDefs.unshift(firstColumns);
    return data;
  },
  computed: {
    showWindow(){
      if(this.$route.path==='/wire_details'){
        return true;
      }
      return false;
    },
  },
  methods:{
    sendData: function(type,data){
         
         let that = this;
         const params = new URLSearchParams();
         params.append('type', type);
         switch(type){
         
           case 'add-bank':
               
             const allowedCountries = this.params.selectedAllowedCountries ? this.params.selectedAllowedCountries.map(country => country.cl_Country) : [];
             const blockedCountries = this.params.selectedBlockedCountries ? this.params.selectedBlockedCountries.map(country => country.cl_Country): [];
             console.log(this.params.selectedAllowedCountries)
             console.log(allowedCountries)
             params.append('allowed_countries', JSON.stringify(allowedCountries));
             params.append('blocked_countries', JSON.stringify(blockedCountries));
             params.append('beneficiary_name', this.params.beneficiary_name);
             params.append('beneficiary_address', this.params.beneficiary_address);
             params.append('bank_name', this.params.bank_name);
             params.append('bank_address', (this.params.bank_address));
             params.append('iban', this.params.iban);
             params.append('swift', this.params.swift);
             params.append('currency', this.params.currency);
             params.append('country', this.params.country.cl_Country);
             params.append('incoming_commission', this.params.commission);
             
             break;
           case 'remove-bank':
             params.append('token', data.token);
            
             
             break;
           
         }
         this.$vs.loading();
         axios.post("/api/banking",params)
        
         .then((data) => {
           that.$vs.loading.close();
           
           if(data.data[0].out1==='done!'){

            // that.componentKey += 1;
             that.popupAddBank=false;
             that.$refs.tableView.setData();
             that.openAlert('success','Success',data.data[0].out1);
           } else{
             that.openAlert('danger','Failed',data.data[0].out1);
           }
           })
         .catch((error) => { console.log('e',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
       },
       openAlert(color,title,text) {
       let colorAlert = color;
       this.$vs.notify({
           title: title,
           text: text,
           color: colorAlert
       })
     },
  }
}
</script>
